import { requestGlobalSettingData } from "../../apis";
import localStorageKey from "../../enumerations/localStorageKey";

const currency =
  window.localStorage.getItem(localStorageKey.DEFAULT_CURRENCY) ||
  process.env.REACT_APP_DEFAULT_CURRENCY;

export const apiGameSearch = (params) =>
  requestGlobalSettingData(
    "get",
    params.game_category_code
      ? `/${currency}/game/v1/list/${params.game_category_code}`
      : `/${currency}/game/v1/list`,
    params,
    false,
    true,
  );
